import { render, staticRenderFns } from "./ReservationsForm.vue?vue&type=template&id=2dcbbff8&scoped=true"
import script from "./ReservationsForm.vue?vue&type=script&lang=js"
export * from "./ReservationsForm.vue?vue&type=script&lang=js"
import style0 from "./ReservationsForm.vue?vue&type=style&index=0&id=2dcbbff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbbff8",
  null
  
)

export default component.exports